import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import OperateTabs_7 from "examples/Tabs/OperateTabs_7";

function Operate_7() {
  return (
    <DashboardLayout>
      <OperateTabs_7 />
    </DashboardLayout>
  );
}

export default Operate_7;
